import { render, staticRenderFns } from "./SoftwareLicenseManagement.vue?vue&type=template&id=2143d194"
import script from "@/scripts/adminManager/systemManager/softwareLicenseManagement.js?vue&type=script&lang=js&external"
export * from "@/scripts/adminManager/systemManager/softwareLicenseManagement.js?vue&type=script&lang=js&external"
import style0 from "./SoftwareLicenseManagement.vue?vue&type=style&index=0&id=2143d194&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports